import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import TextArea from 'antd/lib/input/TextArea';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import LabelValue from '../../atoms/LabelValue';
import CustomModal from '../../molecules/Modal';

function ModalDenyReopening({ open, onCancelClick, onConfirmClick, benefitOrder }) {
  const [justification, setJustification] = useState('');

  return (
    <CustomModal
      title="Reprovar Alteração do Período"
      okText="Confirmar"
      cancelText="Cancelar"
      onCancel={onCancelClick}
      width={400}
      onOk={() => onConfirmClick(justification)}
      open={open}
      afterClose={() => {
        setJustification('');
      }}
    >
      <LabelValue
        label="Justificativa do Gestor"
        value={benefitOrder && benefitOrder.reopeningJustification}
        size="small"
      />
      <br />
      <Label label="Observação (Opcional)">
        <TextArea
          placeholder="Insira aqui uma observação ou comentário"
          rows={6}
          value={justification}
          maxLength={1000}
          type="text"
          onChange={(e) => setJustification(e.target.value)}
        />
      </Label>
    </CustomModal>
  );
}

ModalDenyReopening.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  benefitOrder: PropTypes.shape,
};

ModalDenyReopening.defaultProps = {
  benefitOrder: undefined,
};

export default ModalDenyReopening;
